import React from 'react'
import './button-close.scss'
const ButtonClose = ({ children, className = '', onClick = evt => { } }) => {
    return (
        <button className={'f-button-close ' + className} onClick={onClick}>
           X
        </button>
    )
}

export default ButtonClose
